import { render } from "./ExamResult.vue?vue&type=template&id=67bb53aa&scoped=true"
import script from "./ExamResult.vue?vue&type=script&lang=js"
export * from "./ExamResult.vue?vue&type=script&lang=js"

import "./ExamResult.vue?vue&type=style&index=0&id=67bb53aa&lang=scss&scoped=true"

import exportComponent from "/Users/icesea/WebstormProjects/fpcs-h5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67bb53aa"]])

export default __exports__